import { render } from "./AllDistributorsView.vue?vue&type=template&id=51c2c20c"
import script from "./AllDistributorsView.vue?vue&type=script&lang=js"
export * from "./AllDistributorsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__